import React, { useState, useEffect, Suspense } from 'react';
import { useReactiveMessage } from '@aperza/ui';
import ReactDOM from 'react-dom';
import CatalogPartnerModal from './CatalogPartnerModal';
export const CatalogPartnerModalLoader = () => {
    const [documentId, setDocumentId] = useState();
    const [show, setShow] = useState(false);
    const { getMessage } = useReactiveMessage('CATALOG_PARTNER');
    let subscription;
    useEffect(() => {
        subscription = getMessage().subscribe((message) => {
            if (message && message.documentId) {
                setDocumentId(message.documentId);
                setShow(true);
            }
        });
    });
    const onCloseHandler = () => {
        setShow(false);
    };
    return (React.createElement(CatalogPartnerModal, { documentId: documentId, show: show, onCloseHandler: onCloseHandler }));
};
CatalogPartnerModalLoader.displayName = 'CatalogPartnerModalLoader';
export default CatalogPartnerModalLoader;
const renderCatalogPartnerModal = () => {
    const modalId = 'aperza-catalog-partner-preview-modal';
    const modal = document.getElementById(modalId);
    if (!modal) {
        const aperzaCatalogPartnerPreviewModal = document.createElement('div');
        aperzaCatalogPartnerPreviewModal.id = modalId;
        document.body.appendChild(aperzaCatalogPartnerPreviewModal);
        console.log('ADD aperzaCatalogPartnerPreviewModal');
        ReactDOM.render(React.createElement(Suspense, { fallback: React.createElement("div", null) },
            React.createElement(CatalogPartnerModalLoader, null)), aperzaCatalogPartnerPreviewModal);
    }
    else {
        console.warn(`Trying to create additional modal: ${modalId}`);
    }
};
export { renderCatalogPartnerModal };
